import * as React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { RootState } from '../../reducers';
import { StudentData } from '../../models/Student';
import { GroupData } from '../../models/Group';
import Logout from '../Common/logout';

export namespace SelectCampaign {
	export interface Props extends RouteComponentProps<void> {
		student: StudentData;
		group: GroupData;
	}

	export interface State {
		/* empty */
	}
}

@connect(mapStateToProps, mapDispatchToProps)
export default class SelectCampaign extends React.Component<SelectCampaign.Props, SelectCampaign.State> {

	static contextTypes = {
		router: React.PropTypes.func.isRequired
	}

	constructor(props: SelectCampaign.Props) {
		super(props);
	}

	openCampaign(e: any, id: string) {
		e.preventDefault();

		this.context.router.history.push("/campaign/" + id);
	}

	render() {
		const { group, student } = this.props;
		let campaigns = [];

		if(!group) return <div/>;

		for(let i = 0; i < group.campaigns.length; i++){
			if(group.campaigns[i].active){
				campaigns.push(
					<div onClick={(e)=>this.openCampaign(e, group.campaigns[i]._id)} className="am_altering p-2">
						<img src="images/RedCube.png" className="am_icon"/>
						{group.campaigns[i].name}
					</div>
				);
			}
		}

		return (
			<div>
				<div className="am_mainLogoContainer">
					<img className="margin30 am_mainLogo" src="/images/NarrapixBetaLogo.png" />
				</div>
				<h3 className="am_title text-center margin30">Tervetuloa, {student.firstname + " " + student.lastname}</h3>
				<div className="jumbotron am_studentcontainer col-6 offset-3">
					<h3 className="am_title mb-3">Valitse arviointikampanja:</h3>
					<div className="am_whitecontainer col-12 p-2">
						{campaigns}
					</div>
				</div>
				<div className="am_centerLogout">
					<Logout />
				</div>
			</div>
		);
	}
}

function mapStateToProps(state: RootState) {
	return {
		student: state.student,
		group: state.groups[0]
	};
}

function mapDispatchToProps(dispatch: Dispatch<Function>) {
	return {
	};
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/SelectCampaign/index.tsx